/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AddressInput from './AddressInput/index'
import Appointment from './Appointment/index'
import BooleanInput from './BooleanInput/index'
import CbsWelcome from './CbsWelcome/index'
import Choice from './Choice/index'
import ContactInput from './ContactInput/index'
import DateInput from './DateInput/index'
import ImageCapture from './ImageCapture/index'
import Location from './Location/index'
import MultipleChoice from './MultipleChoice/index'
import No from './No/index'
import PhoneInput from './PhoneInput/index'
import React from 'react'
import TextInput from './TextInput/index'
import Welcome from './Welcome/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let questionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: questionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CbsWelcome'}>
<CbsWelcome
  viewPath={`${viewPath}/CbsWelcome`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Choice'}>
<Choice
  viewPath={`${viewPath}/Choice`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BooleanInput'}>
<BooleanInput
  viewPath={`${viewPath}/BooleanInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MultipleChoice'}>
<MultipleChoice
  viewPath={`${viewPath}/MultipleChoice`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AddressInput'}>
<AddressInput
  viewPath={`${viewPath}/AddressInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ContactInput'}>
<ContactInput
  viewPath={`${viewPath}/ContactInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TextInput'}>
<TextInput
  viewPath={`${viewPath}/TextInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PhoneInput'}>
<PhoneInput
  viewPath={`${viewPath}/PhoneInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DateInput'}>
<DateInput
  viewPath={`${viewPath}/DateInput`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Location'}>
<Location
  viewPath={`${viewPath}/Location`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Welcome'}>
<Welcome
  viewPath={`${viewPath}/Welcome`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImageCapture'}>
<ImageCapture
  viewPath={`${viewPath}/ImageCapture`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Appointment'}>
<Appointment
  viewPath={`${viewPath}/Appointment`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}